<template>
    <AppLayout>
        <PageHero title="Contact Us" description="We'd love to hear from you — reach out with any questions."
            image="/images/courses/quran.jpg" />

        <Container>
            <div class="cms-content mx-auto max-w-3xl py-16" v-html="contactUs ? contactUs.content : '...'"></div>
        </Container>
    </AppLayout>
</template>

<script setup>
import AppLayout from '@/components/layouts/AppLayout.vue';
import Container from '@/components/ui/Container.vue';
import PageHero from '@/components/ui/PageHero.vue';
import { ref } from 'vue';
import { getContactUs } from '@/services/pageService';

const contactUs = ref(null);

const fetchContactUs = async () => {
    const response = await getContactUs();
    contactUs.value = response.data;
}

fetchContactUs();
</script>
